<script setup>
/* eslint-disable @intlify/vue-i18n/no-raw-text, vue/no-bare-strings-in-template */
// Tela de conferir (decisão 30): a conferência da campanha, a mensagem já
// resolvida para a primeira pessoa REAL do público, o nome da campanha e o botão
// que diz em texto o que falta.
import Button from 'dashboard/components-next/button/Button.vue';
import Input from 'dashboard/components-next/input/Input.vue';

defineProps({
  // Nome da campanha: chegou aqui vindo do passo 1, que nem sempre aparece.
  state: { type: Object, required: true },
  channelLabel: { type: String, default: '' },
  inboxName: { type: String, default: '' },
  receiving: { type: Number, default: 0 },
  excluded: { type: Number, default: 0 },
  whenLabel: { type: String, default: '' },
  finishLabel: { type: String, default: '' },
  previewMessage: { type: String, default: '' },
  previewRecipientName: { type: String, default: '' },
  previewLoading: { type: Boolean, default: false },
  missingLabel: { type: String, default: '' },
  submitting: { type: Boolean, default: false },
  canSaveDraft: { type: Boolean, default: false },
});

const emit = defineEmits(['submit', 'saveDraft']);
</script>

<template>
  <aside
    class="flex flex-col gap-3 p-4 border rounded-2xl border-n-weak bg-n-alpha-2 lg:sticky lg:top-0"
    aria-label="Resumo da campanha"
  >
    <h3 class="text-sm font-semibold text-n-slate-12">Resumo</h3>

    <div class="flex flex-col gap-1">
      <Input
        v-model="state.title"
        data-testid="campaign-title"
        label="Nome da campanha"
        placeholder="Ex.: Repescagem proposta setembro"
      />
      <p class="text-xs text-n-slate-11">
        Só vocês veem este nome. Serve para achar a campanha depois.
      </p>
    </div>

    <dl class="flex flex-col gap-1.5 text-xs">
      <div class="flex justify-between gap-2">
        <dt class="text-n-slate-11">Sai por</dt>
        <dd class="font-medium text-right text-n-slate-12">
          {{ inboxName || channelLabel || 'ainda não escolhido' }}
        </dd>
      </div>
      <div class="flex justify-between gap-2">
        <dt class="text-n-slate-11">Para</dt>
        <dd class="font-medium text-right text-n-slate-12">
          <span v-if="previewLoading">conferindo...</span>
          <span v-else>{{ receiving }} pessoas</span>
        </dd>
      </div>
      <div v-if="excluded" class="flex justify-between gap-2">
        <dt class="text-n-slate-11">De fora</dt>
        <dd class="font-medium text-right text-n-amber-11">{{ excluded }}</dd>
      </div>
      <div class="flex justify-between gap-2">
        <dt class="text-n-slate-11">Quando</dt>
        <dd class="font-medium text-right text-n-slate-12">{{ whenLabel }}</dd>
      </div>
      <div v-if="finishLabel" class="flex justify-between gap-2">
        <dt class="text-n-slate-11">Termina em cerca de</dt>
        <dd class="font-medium text-right text-n-slate-12">{{ finishLabel }}</dd>
      </div>
    </dl>

    <div class="flex flex-col gap-1.5">
      <p class="text-xs text-n-slate-11">
        Como chega<template v-if="previewRecipientName">
          para {{ previewRecipientName }}</template
        >
      </p>
      <p
        v-if="previewMessage"
        class="px-3 py-2 text-xs whitespace-pre-line rounded-xl rounded-br-sm bg-n-alpha-black2 text-n-slate-12"
        data-testid="summary-preview"
      >
        {{ previewMessage }}
      </p>
      <p v-else class="text-xs text-n-slate-10">
        Volte ao passo "O que diz" e escreva a mensagem para ver como ela chega.
      </p>
    </div>

    <div class="flex flex-col gap-1.5">
      <Button
        :label="
          submitting
            ? 'Criando...'
            : `Enviar para ${receiving} ${receiving === 1 ? 'pessoa' : 'pessoas'}`
        "
        :disabled="!!missingLabel || submitting || receiving === 0"
        color="blue"
        size="sm"
        data-testid="campaign-submit"
        @click="emit('submit')"
      />
      <p v-if="missingLabel" class="text-xs text-n-amber-11" role="status">
        Falta: {{ missingLabel }}
      </p>
      <p v-else-if="receiving === 0" class="text-xs text-n-amber-11" role="status">
        Falta: um público com pelo menos uma pessoa
      </p>
      <Button
        v-if="canSaveDraft"
        label="Salvar rascunho"
        variant="faded"
        color="slate"
        size="sm"
        :disabled="submitting"
        @click="emit('saveDraft')"
      />
      <p class="text-xs text-n-slate-10">
        Roda no servidor: vocês podem fechar a aba. Dá para pausar em Campanhas.
      </p>
    </div>
  </aside>
</template>
